module.exports = __webpack_public_path__ + "static/media/harris.cda4156d.png";